import React, { memo, useContext } from 'react'
import { ManagerTag } from 'transfix-ui/components/ManagerTag'
import { Grid, Box } from 'transfix-ui/core'
import { IRateType, IRate } from 'types/contractLanes'
import {
  LaneRemoveModalContext,
  EditLaneModalContext,
} from 'utils/routingGuides/LaneModal/contexts'
import { routingGuideRowPropsToIRate } from 'apps/carrier/utils/routingGuideRowPropsToIRate'
import { RoutingGuideRowProps } from 'apps/marketplace/apiTypes/carrierRoutingGuides'
import { showContractLane } from 'apps/marketplace/utils/actions/contractLaneModal'
import { Dropdown, IDropdownOption, DropdownIconType } from 'components/forms'
import formatCurrency from 'utils/formatCurrency'
import { timeSinceShort } from 'utils/formatDatetime'
import { SpecificLane } from './SpecificLane'

export const RoutingGuidesRow = memo<RoutingGuideRowProps>(routingGuide => {
  const {
    approvedAt,
    contractId,
    createdAt,
    createdBy,
    delivery,
    deliveryRadiusMiles,
    equipment,
    isOnlyDropTrailer,
    pickup,
    pickupRadiusMiles,
    rate,
    rateType,
    shipper,
  } = routingGuide
  const { id: equipmentId } = equipment || {}
  const { city: pickupCity, stateCode: pickupStateCode } = pickup || {}
  const { city: deliveryCity, stateCode: deliveryStateCode } = delivery || {}

  const specificLane = {
    pickupCity,
    pickupStateCode,
    pickupRadiusMiles,
    equipmentId,
    deliveryCity,
    deliveryStateCode,
    deliveryRadiusMiles,
    isOnlyDropTrailer,
    shipper,
  }

  const irateRG: IRate = routingGuideRowPropsToIRate(routingGuide)
  const showContract = showContractLane(irateRG)
  const { dispatch: laneRemoveModalDispatch } = useContext(LaneRemoveModalContext)
  const { dispatch: editLaneModalDispatch } = useContext(EditLaneModalContext)

  const options: IDropdownOption[] = [
    { label: 'Edit', action: () => editLaneModalDispatch(showContract) },
    { label: 'Delete', action: () => laneRemoveModalDispatch(showContract) },
  ]

  const { firstName, fullName, lastName } = createdBy

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <SpecificLane specificLane={specificLane} />
      </Grid>
      <Grid item xs={2}>
        <Box mt={2}>
          {rate ? (
            <span>
              {formatCurrency(rate)}
              {rateType === IRateType.rpm ? '/mi' : ''}
            </span>
          ) : (
            'No rate'
          )}
        </Box>
        {approvedAt && <span className='row text-secondary'>Contract</span>}
      </Grid>
      <Grid item xs={3}>
        <Box pr={0} display='flex'>
          <Box pr={0} mt={1}>
            <ManagerTag type='owner' fullName={fullName} />
          </Box>
          <Box pr={0}>
            <strong>
              {firstName}&nbsp;{lastName}
            </strong>
            <span className='row text-secondary'>{timeSinceShort(createdAt)}</span>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={2}>
        <Box mt={2} display='flex'>
          <strong>
            <a
              href={`${__ROOT__}/lane?carrierContractLaneId=${contractId}`}
              target='_blank'
              rel='noopener noreferrer'>
              View Routing Guides
            </a>
          </strong>
        </Box>
      </Grid>
      <Grid item xs={1}>
        <Box mt={3}>
          <Dropdown options={options} icon={DropdownIconType.ellipsis} />
        </Box>
      </Grid>
    </Grid>
  )
})
